import { useEffect, useState } from "react";
import { navLinks } from "../../../mocks/homeData";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 h-16 md:h-[68px]">
        <a href="#top" className="flex items-center gap-2" aria-label="92爆料 返回顶部">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-message-3-fill text-base"></i>
          </span>
          <h1 className="font-heading text-xl md:text-2xl font-black tracking-tight text-foreground-950 whitespace-nowrap">
            92爆料
          </h1>
        </a>

        <nav className="hidden md:flex items-center gap-8" aria-label="主导航">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <a
            href="#follow"
            className="hidden sm:inline-flex whitespace-nowrap items-center rounded-full border border-foreground-300 px-4 py-2 text-sm font-medium text-foreground-900 hover:border-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            关注频道
          </a>
          <a
            href="#entrance"
            className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-add-line text-base"></i>
            私信投稿
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden flex h-10 w-10 items-center justify-center rounded-lg border border-background-300 text-foreground-900 cursor-pointer"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}